import { useTranslation } from "react-i18next";
import PageBreadcrumb from "../../../../shared/ui/common/PageBreadCrumb";
import PageMeta from "../../../../shared/ui/common/PageMeta";
import GroupPatientAddForm from "../components/AddForm/GroupPatientAddForm";
import { useTherapist } from "../../../../context/TherapistProvider";

export default function AddGroupPatient() {
    const { t } = useTranslation();
    const { therapist } = useTherapist();

    return (
        <div>
            <PageMeta title={t("patient.group.newTitle")} />
            <PageBreadcrumb pageTitle={t("patient.group.newTitle")} />
            <div className="flex w-full justify-center pb-12 pt-8">
                <div className="w-full max-w-xl">
                    <GroupPatientAddForm therapistID={therapist?.id ?? ""} />
                </div>
            </div>
        </div>
    );
}
